import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications } from '../helpers';
import { DeleteDesignDocument } from './delete.generated';

export const useDeleteDesign = () => {
  const { t } = useTranslation();
  return useMutation(DeleteDesignDocument, {
    ...useNotifications(DeleteDesignDocument, {
      failure: t('api.common.error_generic'),
      success: (data) => {
        const count = data.deleteDesign?.deletedIds.length ?? 0;
        return t('api.designs.delete_success_plural', { count });
      },
    }),
    update(cache, { data }) {
      if (!data?.deleteDesign?.deletedIds.length) return;
      data.deleteDesign.deletedIds.forEach((id) => cache.evict({ id: `Design:${id}` }));
    },
  });
};
